import { Switch, Route, withRouter } from "react-router-dom";
import Header from "layout/Header/Header";
import Footer from "layout/Footer/Footer";

const components = [
    { name: "Home", path: "/" },
    { name: "Home", path: "/Home" },
    { name: "Stake", path: "/stake" },
    { name: "Home", path: "" },
];

const AppRoute = () => {
    return (
        <>
            <Route
                render={({ location }) => {
                    window.scrollTo({ top: 0, behavior: "smooth" })
                    return (
                        <>
                        {location.pathname === '/stake' ? null:<Header /> }
                        <Switch
                            location={location}
                            key={location.pathname}>
                            {components.map((el, i) => {
                                const Component = require(`../container/${el.name}`)[
                                    el.nested || "default"
                                ];
                                return (
                                    <Route key={i} path={el.path} component={Component} exact />
                                );
                            })};
                        </Switch>
                        </>
                    );
                }}
            />
            <Footer />
        </>
    );
};

export default withRouter(AppRoute);
